/**
 * Os dois jeitos de ler a lista de menções (seletor "Ver:"): a Lista de
 * sempre e a Revisão (uma a uma, em três painéis). As justificativas têm
 * página própria (`/justificativas`), não são um terceiro modo.
 *
 * A escolha fica no `localStorage`. Qualquer valor fora do vocabulário —
 * chave apagada, texto de versão futura (a primeira versão das
 * justificativas gravou `why` aqui) — cai na Lista, que é o padrão.
 */

export type ReadingMode = "list" | "review";

export const READING_MODES: readonly ReadingMode[] = ["list", "review"];

export function parseReadingMode(raw: string | null | undefined): ReadingMode {
  return READING_MODES.includes(raw as ReadingMode) ? (raw as ReadingMode) : "list";
}
